import React, { Component } from 'react';
import JourneyCardContext from './journeyCardContext';

const journeyCardEnhancer = (selectors) => (WrappedComponent) =>
  class extends Component {
    render() {
      return (
        <JourneyCardContext.Provider value={selectors}>
          <WrappedComponent {...WrappedComponent.props} {...this.props} />
        </JourneyCardContext.Provider>
      );
    }
  };

export default journeyCardEnhancer;
